module.exports = __webpack_public_path__ + "img/001.6fa4ebf6.png";